import styled from '@emotion/styled'
import darken from 'polished/lib/color/darken'

import { palette, spacing, Text, typography } from 'main/ui'

export const OnMoveContainer = styled.div`
  background-color: ${palette.white};
  border-radius: 3px;
  left: ${spacing.majorScale(1)}px;
  padding: ${spacing.majorScale(1)}px;
  position: absolute;
  top: ${spacing.majorScale(1)}px;
`

export const OnRequestContainer = styled.div`
  display: flex;
  pointer-events: none;
  position: absolute;
  top: ${spacing.majorScale(2)}px;
  width: 100%;
`

export const OnRequestButton = styled(Text.withComponent('button'))`
  background-color: ${palette.skyBlue2};
  border: none;
  border-radius: 3px;
  color: ${palette.white};
  cursor: pointer;
  font-weight: ${typography.fontWeight.bold};
  margin-left: auto;
  margin-right: auto;
  padding: ${spacing.majorScale(1)}px ${spacing.majorScale(2)}px;
  pointer-events: auto;

  &:focus {
    outline: none;
  }

  &:hover {
    background-color: ${darken(0.1, palette.skyBlue2)};
    color: ${palette.white};
  }
`
